export const sidebarData = [
  {
    userId: "tenderlist",
    subMenu: null,
    name: "Tender List",
  },
  {
    userId: "dashboard",
    subMenu: null,
    name: "Dashboard",
  },
  {
    userId: "mywishlist",
    subMenu: null,
    name: "My Wish List",
  },

  {
    userId: "myrequested",
    subMenu: null,
    name: "Requested Tenders",
  },
  {
    userId: "myquotes",
    subMenu: null,
    name: "My requests",
  },

  {
    userId: "pricing",
    subMenu: null,
    name: "Pricing",
  },
  {
    userId: "requestdemo",
    subMenu: null,
    name: "Request Demo",
  },
];
